import React, { useContext } from "react";
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { HiChevronDoubleLeft, HiChevronDoubleRight } from 'react-icons/hi';
import { TableContext } from "./TableContext";
import { lang } from '../../Utils';

const Paginator = () => {

  const context = useContext(TableContext);
  if (!!context.filteredItems && context.filteredItems.length > 0) {
    return (<div className="bf-paginator">
      <div className="sizes">
        <div>
          {lang('Items per page')}
          <select onChange={(event) => context.setSize(event.target.value)} value={context.options.size}>
            {(context.options.sizes.map((value, index) => <option key={index} value={value}>{value}</option>))}
          </select>
        </div>
        <div>
          {lang('Page')} {context.options.page} {lang('of')} {context.options.pages}
        </div>
      </div>
      <div className="pages">
        <button disabled={context.options.page === 1} type="button" onClick={() => context.setPage(1)}><HiChevronDoubleLeft size={20} /></button>
        <button disabled={context.options.page === 1} type="button" onClick={() => context.setPage(context.options.page - 1)}><MdOutlineKeyboardArrowLeft size={20} /></button>
        <button disabled={context.options.page === context.options.pages} type="button" onClick={() => context.setPage(context.options.page + 1)}><MdOutlineKeyboardArrowRight size={20} /></button>
        <button disabled={context.options.page === context.options.pages} type="button" onClick={() => context.setPage(context.options.pages)}><HiChevronDoubleRight size={20} /></button>
      </div>
    </div>)
  } else {
    return null;
  }

}

export { Paginator };